import { render } from "./value-settinggl.vue?vue&type=template&id=a8475698"
import script from "./value-settinggl.vue?vue&type=script&lang=js"
export * from "./value-settinggl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__